import Slider from 'react-slick';
import classNames from 'classnames';
import { hoc } from '../../../packages';
import { useCarousel } from './carousel.props';
import styles from './carousel.module.scss';

/**
 * Renders Carousel
 */
const Carousel = hoc(
  useCarousel,
  ({
    carouselRef,
    className,
    selectedIndex,
    setSelectedIndex,
    checkIsArrowHidden,
    children,
    onClickPrevSlide,
    onClickNextSlide,
    showArrows,
    count,
    ...props
  }) => {
    // const _count = count ?? Children.count(children);

    return (
      <div className={styles.container}>
        <Slider
          ref={carouselRef}
          className={classNames(styles.carousel, className)}
          dots={false}
          beforeChange={(_: any, index: any) => setSelectedIndex(index)}
          {...props}
        >
          {children}
        </Slider>

        {showArrows && (
          <>
            <div className={styles.arrows} onClick={onClickPrevSlide}>
              <img
                width='35px'
                height='35px'
                className={classNames(styles.arrow)}
                src='/img/arrow-carousel.svg'
                alt='arrow-left'
              />
            </div>

            <div
              className={classNames(styles.arrows, styles['arrow-right'])}
              onClick={onClickNextSlide}
            >
              <img
                width='35px'
                height='35px'
                className={classNames(styles.arrow)}
                src='/img/arrow-carousel.svg'
                alt='arrow-right'
              />
            </div>
          </>
        )}

        {/* {_count > 1 && (
          <div className={styles.indicators}>
            {Children.map(children, (_, index) => (
              <div
                className={classNames(styles.indicator, {
                  [styles.indicator_active]: index === selectedIndex
                })}
                //@ts-ignore
                onClick={() => carouselRef.current.slickGoTo(index)}
              />
            ))}
          </div>
        )} */}
      </div>
    );
  }
);

export { Carousel };
